import { State, Action, StateContext, Selector, Store, Select } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { RemindPassword, RemindPasswordSuccess } from './remind-password.action';
import { AuthenticationService } from '../../services/authentication.service';



export interface IPReminderStateModel {
    state: any;
}

@State<IPReminderStateModel>({
    name: 'preminderState',
    defaults: {
        state: ''
    }
})

@Injectable()

export class RemindPasswordState {

    constructor(
                private store: Store,
                private authService: AuthenticationService
                ) { }

    @Action(RemindPassword)
    remindPassword(
        context: StateContext<IPReminderStateModel>,
        action: RemindPassword
     ) {
        this.authService.remindPassword(action.username, action.appname).subscribe( ret => {
            context.dispatch(new RemindPasswordSuccess('Reminded'));
        });

    }

    @Action(RemindPasswordSuccess)
    remindPasswordSuccess(
        context: StateContext<IPReminderStateModel>,
        action: RemindPasswordSuccess
    ) {
        context.setState({
            state: 'LogEntry - Success'
        });
    }


}
